import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
// Import the generated route tree
import { routeTree } from "./routeTree.gen.ts";

import "./styles.css";
import reportWebVitals from "./report-web-vitals.ts";
import "./i18n/index.ts";
import { captureReactErrors, initSentry } from "./lib/sentry.tsx";
import { SessionProvider } from "./providers/session-provider.tsx";
import { getQueryClientContext, TanStackQueryProvider } from "./providers/tanstack-query-provider.tsx";

if (import.meta.env.DEV) {
	const { scan } = await import("react-scan");

	const isPlaywright = localStorage.getItem("isPlaywright") === "true";
	scan({ enabled: !isPlaywright });
}

// Create a new router instance
const router = createRouter({
	routeTree,
	context: {
		...getQueryClientContext(),
	},
	defaultPreload: "intent",
	scrollRestoration: true,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
});

initSentry({ router });

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	// biome-ignore lint/style/useConsistentTypeDefinitions: Required
	interface Register {
		router: typeof router;
	}
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement, captureReactErrors);

	root.render(
		<StrictMode>
			<TanStackQueryProvider>
				<SessionProvider>
					<RouterProvider router={router} />
				</SessionProvider>
			</TanStackQueryProvider>
		</StrictMode>
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
